<script setup lang="ts">
import moment from 'moment';
import { ref, onMounted, watch } from 'vue';
const { $emitter } = useNuxtApp();
const date = defineModel();
const datepicker = ref(null);

const formatDate = (dateRange) => {
    const startDate = dateRange[0];
    const endDate = dateRange[1];
    return `${padDateComponent(startDate.getDate())}.${padDateComponent(
        startDate.getMonth() + 1
    )}.${startDate.getFullYear()} - ${padDateComponent(
        endDate.getDate()
    )}.${padDateComponent(endDate.getMonth() + 1)}.${endDate.getFullYear()}`;
};

const padDateComponent = (dateComponent) => {
    return dateComponent.toString().padStart(2, '0');
};
const changedate = () => {
    $emitter.emit('selectdate');
};
const saveDate = (newDate: [Date, Date]) => {
    localStorage.setItem('startDate', moment(newDate[0]).format('YYYY-MM-DD'));
    localStorage.setItem('endDate', moment(newDate[1]).format('YYYY-MM-DD'));
    changedate();
};

const setDateRange = (option) => {
    const today = new Date();
    switch (option) {
        case 'today':
            date.value = [today, today];
            break;
        case 'yesterday':
            date.value = [
                new Date(today.setDate(today.getDate() - 1)),
                new Date(today.setDate(today.getDate())),
            ];
            break;
        case 'this_month':
            date.value = [
                new Date(today.getFullYear(), today.getMonth(), 1),
                new Date(today.getFullYear(), today.getMonth() + 1, 0),
            ];
            break;
        case 'last_month':
            date.value = [
                new Date(today.getFullYear(), today.getMonth() - 1, 1),
                new Date(today.getFullYear(), today.getMonth(), 0),
            ];
            break;
        case 'this_year':
            date.value = [new Date(today.getFullYear(), 0, 1), today];
            break;
        case 'last_year':
            date.value = [
                new Date(today.getFullYear() - 1, 0, 1),
                new Date(today.getFullYear() - 1, 11, 31),
            ];
            break;
    }
    saveDate(date.value);
    datepicker.value.closeMenu();
};
onMounted(() => {
    const storedStartDate = localStorage.getItem('startDate');
    const storedEndDate = localStorage.getItem('endDate');
    const today = new Date();

    if (
        storedStartDate &&
        storedEndDate &&
        new Date(storedEndDate).toDateString() == today.toDateString()
    ) {
        date.value = [new Date(storedStartDate), new Date(storedEndDate)];
    } else {
        setDateRange('this_year');
    }
});
watch(date, (newDate) => {
    if (newDate && newDate.length === 2) {
        saveDate(newDate);
        changedate();
    }
});
</script>

<template>
    <vue-datepicker
        ref="datepicker"
        v-model="date"
        locale="de"
        :format="formatDate"
        range
        :multi-calendars="{ solo: true }"
        :clearable="false"
        :enable-time-picker="false"
        auto-apply
        :auto-position="true"
        @update:modelValue="saveDate"
    >
        <template #action-row></template>
        <template #left-sidebar>
            <div class="p-4 text-sm min-w-40">
                <div
                    class="hover:bg-grey-lighter p-1 cursor-pointer"
                    @click="setDateRange('today')"
                >
                    {{ $t('datepicker.today') }}
                </div>
                <div
                    class="hover:bg-grey-lighter p-1 cursor-pointer"
                    @click="setDateRange('yesterday')"
                >
                    {{ $t('datepicker.yesterday') }}
                </div>
                <div
                    class="hover:bg-grey-lighter p-1 cursor-pointer"
                    @click="setDateRange('this_month')"
                >
                    {{ $t('datepicker.this_month') }}
                </div>
                <div
                    class="hover:bg-grey-lighter p-1 cursor-pointer"
                    @click="setDateRange('last_month')"
                >
                    {{ $t('datepicker.last_month') }}
                </div>
                <div
                    class="hover:bg-grey-lighter p-1 cursor-pointer"
                    @click="setDateRange('this_year')"
                >
                    {{ $t('datepicker.this_year') }}
                </div>
                <div
                    class="hover:bg-grey-lighter p-1 cursor-pointer"
                    @click="setDateRange('last_year')"
                >
                    {{ $t('datepicker.last_year') }}
                </div>
            </div>
        </template>
    </vue-datepicker>
</template>

<style>
.dp--menu-wrapper {
    left: 0px !important;
}

.dp__arrow_top {
    left: 119px !important;
}
</style>
